import telehealthAxiosInstance from '@/utils/axios/telehealthAxiosInstance';
import { decodeAuthToken } from '../utils/tokenUtils';
import { ITokboxAppointmentDetails, ITokboxAppointmentType, ISubmitFeedbackResponseTypes, ISubmitFeedbackTypes, ITokboxDetailsResponse } from '@/types';

export const getTokboxValues = ({ appointmentId }: { appointmentId: string | null }) => {
  return {
    queryKey: ['getTokboxValues'],
    queryFn: async () => {
      const { memberId, organisationId } = decodeAuthToken() ?? {};
      if (!appointmentId)
        return null
      const url = `organisation/${organisationId}/member/${memberId}/appointments/${appointmentId}/join-call/tokbox`;
      const response = (await telehealthAxiosInstance.get<ITokboxDetailsResponse>(url)).data;

      return response
    },
  };
};

export const getUpcomingConsultations = () => {
  return {
    queryKey: ['getUpcomingConsultations'],
    queryFn: async () => {
      const { memberId, organisationId } = decodeAuthToken() ?? {};
      const url = `organisation/${organisationId}/member/${memberId}/appointments/upcoming-consultations`;
      const params = {
        page: 0,
        limit: 20
      }
      const response = (await telehealthAxiosInstance.get<ITokboxAppointmentDetails>(url, { params })).data;

      return response
    },
  };
}

export const getAppointmentDetails = ({ appointmentId }: { appointmentId: string }) => {
  return {
    queryKey: ['getAppointmentDetails'],
    queryFn: async () => {
      const { memberId, organisationId } = decodeAuthToken() ?? {};
      const url = `organisation/${organisationId}/member/${memberId}/appointments/${appointmentId}`;

      const response = (await telehealthAxiosInstance.get<ITokboxAppointmentType>(url)).data;

      return response
    },
  };
}

export const submitFeedbackQuery = async (body: ISubmitFeedbackTypes) => {

  const data = (await telehealthAxiosInstance.post<ISubmitFeedbackResponseTypes>('/appointment/feedback', body)).data

  return data

}